import { useState } from "react";
import { useAuth } from "@/AuthContext";
import { useLang } from "@/i18n";
import { formatApiError } from "@/api";

export default function LoginForm({ onSuccess }) {
  const { t } = useLang();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const user = await login(email, password);
      if (onSuccess) onSuccess(user);
    } catch (err) {
      setError(formatApiError(err) || t.auth.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-form" className="mx-auto w-full max-w-md">
      <p className="eyebrow">{t.brand}</p>
      <h1 className="mt-3 font-serif text-3xl sm:text-4xl text-maquis-deep">{t.auth.login_title}</h1>
      <p className="mt-2 text-sm text-maquis-soft">{t.auth.login_sub}</p>
      <form onSubmit={submit} className="mt-8 space-y-5">
        <div>
          <label className="field-label">{t.auth.email}</label>
          <input
            data-testid="login-email-input" type="email" required
            value={email} onChange={(e) => setEmail(e.target.value)} className="field-input"
          />
        </div>
        <div>
          <label className="field-label">{t.auth.password}</label>
          <input
            data-testid="login-password-input" type="password" required
            value={password} onChange={(e) => setPassword(e.target.value)} className="field-input"
          />
        </div>
        {error && <p data-testid="login-error" className="text-sm text-red-800">{error}</p>}
        <button
          type="submit" data-testid="login-submit-button" disabled={loading}
          className="btn-outline-elegant w-full text-maquis-deep hover:bg-maquis-deep hover:text-casse disabled:opacity-50"
        >
          {loading ? "…" : t.auth.submit}
        </button>
      </form>
    </div>
  );
}
